import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const getSwitchAccountList = createAsyncThunk("getSwitchAccountList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/oauth/get-all-access-tokens/`);
            const result = response.data;
            return result
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const addSwitchAccount = createAsyncThunk("addSwitchAccount",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/oauth/login/`, data);
            const result = response.data;
            return result
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const removeSwitchAccount = createAsyncThunk("removeSwitchAccount",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`/delete_one_session/`, data);
            const result = response.data;
            return result
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const switchAccount = createAsyncThunk("switchAccount",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/switch_account/`, data);
            const result = response.data;
            return result
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const SwitchAccountSlice = createSlice({
    name: "SwitchAccount",
    initialState: {
        SwitchAccountList: {},
        AccountAdded: {},
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        // Handle switch account action
        builder.addCase(switchAccount.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(switchAccount.fulfilled, (state, action) => {
            state.SwitchAccountList = action.payload;
            state.loading = false;
        });
        builder.addCase(switchAccount.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Handle get switch account list action
        builder.addCase(getSwitchAccountList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getSwitchAccountList.fulfilled, (state, action) => {
            state.SwitchAccountList = action.payload;
            state.loading = false;
        });
        builder.addCase(getSwitchAccountList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Handle add switch account action
        builder.addCase(addSwitchAccount.pending, (state) => {
            state.loading = true;
        }
        );
        builder.addCase(addSwitchAccount.fulfilled, (state, action) => {
            state.AccountAdded = action.payload;
            state.loading = false;
            state.error = null;
        });
        builder.addCase(addSwitchAccount.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default SwitchAccountSlice.reducer;
